import { internalFetch } from '../utils/fetchHelper';
import { getTimeServices, type ITimeService } from './pricingService';
import { asTimeServiceRules, type ITimeServiceRule } from './slaRule';

const base = () => import.meta.env.VITE_BACKEND_API_URL as string;

export const getAllTimeServices = async (
  abortController: AbortController
): Promise<ITimeService[]> => {
  const pageSize = 100;
  const first = await getTimeServices(abortController, pageSize, 1);
  const items = [...first.items];
  for (let pageNo = 2; pageNo <= first.pageCount; pageNo += 1) {
    const page = await getTimeServices(abortController, pageSize, pageNo);
    items.push(...page.items);
  }
  return items.sort(
    (a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name)
  );
};

export const getTimeServiceRules = async (
  abortController: AbortController
): Promise<ITimeServiceRule[]> => {
  const data = await internalFetch(
    `${base()}/p/timeServiceRules`,
    'GET',
    abortController
  );
  return asTimeServiceRules(data);
};

export const getTenantTimeServiceRules = async (
  abortController: AbortController
): Promise<ITimeServiceRule[]> => {
  const data = await internalFetch(
    `${base()}/p/tenantTimeServiceRules`,
    'GET',
    abortController
  );
  return asTimeServiceRules(data);
};

export const saveTenantTimeServiceRule = async (
  abortController: AbortController,
  rule: ITimeServiceRule
): Promise<ITimeServiceRule> => {
  const data = await internalFetch(
    `${base()}/p/tenantTimeServiceRule`,
    'PUT',
    abortController,
    JSON.stringify(rule)
  );
  return asTimeServiceRules([data])[0] ?? rule;
};

export const deleteTenantTimeServiceRule = async (
  abortController: AbortController,
  timeServiceId: number
): Promise<void> => {
  await internalFetch(
    `${base()}/p/tenantTimeServiceRule?timeServiceId=${timeServiceId}`,
    'DELETE',
    abortController,
    undefined,
    true
  );
};
